import { useAppDispatch } from '@shared/redux';
import type { CreateOrganization } from '@shared/api';
import { useCreateOrganizationOrganizationCreatePostMutation } from '@shared/api';
import { authActions } from '@shared/redux/ducks/auth';

export const useCreateOrganization = (onError?: () => void) => {
  const dispatch = useAppDispatch();
  const [createOrganizationMutation, { isLoading }] =
    useCreateOrganizationOrganizationCreatePostMutation();

  const createOrganization = async (values: CreateOrganization) => {
    try {
      const response = await createOrganizationMutation({
        createOrganization: {
          ...values,
        },
      }).unwrap();

      dispatch(
        authActions.setCurrentOrganizationInfo({
          ...response,
          permission: 'OWNER',
        }),
      );
    } catch {
      onError?.();

      throw new Error();
    }
  };

  return { createOrganization, isLoading };
};
